<template>
  <div class="main-page">

    <div class="main-page--navbar">

      <div class="container">
        <div class="row">
          <div class="col-12">
            <div class="main-page--navbar--container">
              <img width="110" src="@/assets/icons/acg-logo-white.svg" alt="Logo">
              <button class="nav-link btn-logout" type="button" @click="logout()">Kijelentkezés</button>
            </div>
          </div>
        </div>
      </div>

    </div>

    <div class="container-xl">
      <div class="row">
        <div class="col">
          <div class="main-page--content">
            
            <ul class="nav nav-tabs" role="tablist" style="border-bottom: none;">
              <li class="nav-item">
                <a class="nav-link active" data-toggle="tab" href="#tabs-1" role="tab">Mérkőzések</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" data-toggle="tab" href="#tabs-2" role="tab">Csapatok</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" data-toggle="tab" href="#tabs-3" role="tab">Tabella</a>
              </li>
              <li class="nav-item mobile-view-tab">
                <a class="nav-link" data-toggle="tab" href="#tabs-5" role="tab">Nyeremények</a>
              </li>
              <li class="nav-item mobile-view-tab">
                <a class="nav-link" data-toggle="tab" href="#tabs-4" role="tab">Játékszabály</a>
              </li>
            </ul>

            <div class="tab-content">

              <div class="tab-pane active" id="tabs-1" role="tabpanel">
                <MatchTable :allMatches="allMatchesByType" />
              </div>

              <div class="tab-pane" id="tabs-2" role="tabpanel">                
                <TeamTable :firstMatchTime="firstMatchTime" v-if="firstMatchTime!= null"/>
              </div>

              <div class="tab-pane" id="tabs-3" role="tabpanel">
                 <BetTable/>
              </div>

              <div class="tab-pane" id="tabs-4" role="tabpanel">
                  <Jatekszabaly/>
              </div>

              <div class="tab-pane" id="tabs-5" role="tabpanel">
                <div class="container-xl nyeremenyek">
                  <div class="col-12">
                    <h1>Nyeremények</h1>
                  </div>
                  <div class="winnings">
                      <img class="winnings-item" src="@/assets/winnings/soproni.png" />
                      <img class="winnings-item" src="@/assets/winnings/eucerin.png" />
                      <img class="winnings-item" src="@/assets/winnings/szotyi.png" />
                      <img class="winnings-item" src="@/assets/winnings/vodka.png" />

                      <img class="winnings-item" src="@/assets/winnings/family.png" />
                      <img class="winnings-item" src="@/assets/winnings/sopi-balaton.png" />
                      <img class="winnings-item" src="@/assets/winnings/napszemcsi.png" />
                      <img class="winnings-item" src="@/assets/winnings/spritz.png" />

                      <img class="winnings-item" src="@/assets/winnings/citrus.png" />
                      <img class="winnings-item" src="@/assets/winnings/family-tolcser.png" />
                      <img class="winnings-item" src="@/assets/winnings/burn-apple.png" />
                      <img class="winnings-item" src="@/assets/winnings/burn-zero.png" />

                      <img class="winnings-item" src="@/assets/winnings/heineken.png" />
                      <img class="winnings-item" src="@/assets/winnings/burn-original.png" />
                      <img class="winnings-item" src="@/assets/winnings/kaktusz.png" />
                      <img class="winnings-item" src="@/assets/winnings/burn-mango.png" />
                </div>
                </div>
              </div>

            </div>

          </div>
        </div>
      </div>
      </div>
      
  </div>
</template>

<script>
import MatchTable from "@/components/MatchTable.vue";
import TeamTable from "@/components/TeamTable.vue";
import BetTable from "@/components/BetTable.vue";
import Jatekszabaly from "@/components/Jatekszabaly.vue";

import viewMI from "@/mixins/viewMI";

export default {
  name: "Main",
  data(){
    return{
      allMatches: [], 
      allMatchesByType:[],
      firstMatchTime: null,
    }
  },
  mixins: [viewMI],
  components: {
    MatchTable,
    TeamTable,
    BetTable,
    Jatekszabaly
  },
  watch:{
    allMatchesByType(){      
      this.firstMatchTime = this.allMatchesByType[0].matches[0].time
    }
  },
  methods: {
    logout() {

      //delete local storage
      localStorage.removeItem('ebus_token')
      this.$store.state.token = null

      //go to login page
      this.$router.push({name: 'LogIn'})
    }, 
    userReady(){
      // this.$store.dispatch("getMatches");   
      this.getMatches()
    },
    getMatches(){
      let _this = this

       this.get('match', {
            params: {
              relations: 1,
              order_by:[['time', 'asc']],
              relations_params:{
                gamble:{
                  relations: 1,
                  relations_params:{
                    user: {
                    }
                  }
                }
              }
            }
          },
          function (response) {
            
            if (response.data.status === true){
              _this.allMatches = response.data.match;
              _this.selectByMatchType()
            } else{
              _this.allMatches = []
            }            
          }, function (error) {
            //error
            console.log('error matches', error)

            _this.allMatches = []
          }
      )
    },
    selectByMatchType(){
      let _this = this

      _this.allMatches.forEach(element => {
          let typeIndex = _this.allMatchesByType.findIndex(item=> item.type === element.type)          

          if (_this.allMatchesByType.length === 0 || typeIndex === -1){                  
            _this.allMatchesByType.push({
              type: element.type,
              matches: [element]
            })
          } else {            
            _this.allMatchesByType[typeIndex].matches.push(element)
          }
      });
      
    }
  },
  created() {
    this.$store.dispatch("getTeams");   
  },
  computed: {
    team() {
      return this.$store.state.team;
    },
    match() {
      return this.$store.state.match;
    },
    gamble() {
      return this.$store.state.gamble;
    },
    // matches(){
    //   return this.$store.state.match
    // }, 
    // firstMatchTime(){
    //   // return this.$store.state.match[0] ? this.$store.state.match[0].time : null
    //   return this.allMatches.length > 0 ? this.allMatches[0].time : null
    // }
  }
}
</script>
